/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { Injectable }    from "@angular/core";
import { type MusicApp } from "@bowstring/types";


@Injectable({ providedIn: "root" })
export class MusicLibraryService {

  public readonly connectedApps: Array<MusicApp>                = [];
  public readonly missingTracks: { [key in MusicApp]?: number } = {};

}
